export const title = {
  en: {
    heading: "Sign In",
    sub_heading: ""
  },
  hi: {
    heading: "साइन इन",
    sub_heading: ""
  },
  or: {
    heading: "ସାଇନ୍ ଇନ୍",
    sub_heading: ""
  }
}

export const subTitle = {
  en: "An AI Assistant to help you with your work related questions",
  hi: "आपके कार्य से संबंधित प्रश्नों में सहायता करने के लिए एक एआई असिस्टेंट ।",
  or: "ଆପଣଙ୍କର କାମ ସମ୍ବନ୍ଧୀୟ ପ୍ରଶ୍ନରେ ସାହାଯ୍ୟ କରିବା ପାଇଁ ଏକ ସହକାରୀ"
}

export const nextConstant = {
      en: "Next",
      hi: "आगे बढ़ें",
      or: "ପରବର୍ତ୍ତୀ"

  };
  export const getOtpConstant = {
    en: "Get OTP",
    hi: "कोड प्राप्त करें",
    or: "ଓଟିପି ପାଆନ୍ତୁ"

};

  export const proceedConstant = {
    en: "Proceed To Participate",
    hi: "भाग लेने के लिए आगे बढ़े",
    or: "ଭାଗ ନେବା ପାଇଁ ଆଗକୁ ବଢ଼ନ୍ତୁ"
  };
  

export const langPreferenceConstantGuide = {
    en: `Welcome! Enter your mobile number to proceed`,
    hi: `Namaste! आगे बढ़ने के लिए अपना मोबाइल नंबर दर्ज करें`,
    or: `ଆଗକୁ ବଢ଼ିବା ପାଇଁ ଆପଣଙ୍କର ମୋବାଇଲ୍ ନମ୍ବର ଦିଅନ୍ତୁ।`,
  }
  

export const languagePreferenceConstant = {
    en: `Select your preferred 
    language`,
    hi: `अपनी पसंदीदा भाषा 
    चुनें`,
    or: `ଭାଷା ବାଛନ୍ତୁ`
  }
export const selectLanguageConstant = {
  en: "Select Language",
  hi: "भाषा चुनें",
  or: "ଭାଷା ଚୟନ କରନ୍ତୁ"
}

export const codeToSvgName = {
  en: "English",
  hi: "Hindi",
  or: "Odia",
  bn: "Bengali",
  ta: "Tamil",
  te: "Telugu",
  mr: "Marathi",
  gu: "Gujarati",
  pa: "Punjabi",
  ml: "Malayam",
  ka: "Kannada",
  ur: "Urdu",
};


  export const guideButtons = {
    next: {
      en: "Next",
      hi: "आगे जाएँ",
      or: "ପରବର୍ତ୍ତୀ",
    },
    previous: {
      en: "Previous",
      hi: "पीछे जाएं",
      or: "ପୂର୍ବ"
    },
    skip: {
      en: "Skip",
      hi: "स्किप करें",
      or: "ଛାଡିଦିଅନ୍ତୁ"
    },
    stop:{
      en:"Click to stop",
      hi:"रोकने के लिए क्लिक करें",
      or: "ବନ୍ଦ କରନ୍ତୁ କ୍ଲିକ୍ କରନ୍ତୁ"
    }
  };
  




  export const devicereadinessAshaIntro = {
    en: "HealthVaani",
    hi: "हेल्थवाणी",
    or: "ହେଲ୍ଥଭାଣୀ"
  };
  
  export const devicereadinessAshaShort = {
    en: "A Chatbot to answer your work queries",
    hi: "आपके काम संबंधी प्रश्नों का उत्तर देने के लिए एक चैटबॉट",
    or: "ଆପଣଙ୍କର କାମ ସମ୍ବନ୍ଧୀୟ ପ୍ରଶ୍ନଗୁଡ଼ିକୁ ଉତ୍ତର ଦେବା ପାଇଁ ଏକ ଚ୍ୟାଟବୋଟ୍"
  };
  
  export const devicereadinessAshaDescriptive = {
    en: `MoHFW is very keen in supporting ASHAs in their daily activities. HealthVaani is a chatbot which  will help you in resolving your queries faced on a daily basis at field level. 
    This link will check whether you are eligible to participate in the pilot program for ASHA chatbot`,
    hi: `MoHFW आशाओं को उनकी दैनिक गतिविधियों में सहयोग देने के लिए बहुत उत्सुक है। आशा हेल्थ असिस्टेंट एक चैटबॉट है जो फील्ड स्तर पर दैनिक आधार पर आने वाले आपके प्रश्नों को हल करने में आपकी मदद करेगा।
    यह लिंक जांच करेगा कि आप आशा चैटबॉट के पायलट कार्यक्रम में भाग लेने के लिए पात्र हैं या नहीं।`,
    or: `MoHFW ଏ.ଏସ୍.ଏଚ୍.ଏମାନେ ଦୈନିକ କାର୍ଯ୍ୟରେ ସହଯୋଗ ପାଇଁ ଅତ୍ୟନ୍ତ ଆଗ୍ରହୀ। ହେଲ୍ଥଭାଣୀ ଏକ ଚ୍ୟାଟବୋଟ୍ ଯାହା ଆପଣଙ୍କୁ ଦୈନିକ ଭାବେ ମାନ୍ୟ ହେଉଥିବା ପ୍ରଶ୍ନଗୁଡିକୁ ମିଦାନ ସ୍ତରରେ ସମାଧାନ କରିବାରେ ସାହାଯ୍ୟ କରିବ।
    ଏହି ଲିଙ୍କ୍ ଆପଣ ଏହି ଆଶା ଚ୍ୟାଟବୋଟ୍ ପାଇଁ ପାଇଲଟ୍ ପ୍ରୋଗ୍ରାମ୍ ରେ ଅଂଶଗ୍ରହଣ ପାଇଁ ଯୋଗ୍ୟ କି ନୁହେଁ ତାହା ଯାଞ୍ଚ କରିବ।`
  };
  
  export const devicereadinessAshaRecording = {
    en: "Ageing is not a disease but the elderly population are more susceptible to various diseases.",
    hi: "हमें गर्भावस्था के समय मां का ख्याल रखना है और उन्हें विटामिन की दो खुराक देनी है।",
    or: "ବୃଦ୍ଧାବସ୍ଥା କୌଣସି ରୋଗ ନୁହେଁ କିନ୍ତୁ ବୃଦ୍ଧ ଲୋକମାନେ ବିଭିନ୍ନ ରୋଗ ପାଇଁ ଅଧିକ ସଂବେଦନଶୀଳ ହୋଇଥାନ୍ତି।"
  };
  
  export const devicereadinessAshaRecordingInstruction = {
    en: "read the given sentence loudly",
    hi: "दिए गए वाक्य को जोर से पढ़ें",
    or: "ଦିଆଯାଇଥିବା ବାକ୍ୟଟିକୁ ଉଚ୍ଚ ସ୍ବରରେ ପଢନ୍ତୁ"
  };
  
export const sendingConstant = {
  en: "Sending...",
  hi: "भेजा जा रहा है...",
  or: "ପଠାଯାଉଛି..."
};
  